module.exports = __webpack_public_path__ + "static/media/insta8.3d72ca2d.jpg";